<div class="modal fade" id="acLineAddModal-1" tabindex="-1" aria-labelledby="addAcLineModalLabel" aria-hidden="true">
  <div style="max-width: 64rem;" class="modal-dialog modal-dialog-centered modal-lg">
    <form (ngSubmit)="save()"   
      style="border-radius: 20px;" class="modal-content rounded-5 shadow-lg border-0">
      <div class="modal-header border-0 pb-0">
        <h5 style="font-size: 2rem;" class="modal-title fw-semibold" id="addAcLineModalLabel">{{ "Add New Incoming AC Line Segment" }}</h5>
        <button type="button" style="border: none; background: transparent;" data-bs-dismiss="modal" aria-label="Zatvori">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" rx="12" fill="#171717" fill-opacity="0.05"/>
            <rect x="0.5" y="0.5" width="23" height="23" rx="11.5" stroke="#171717" stroke-opacity="0.07"/>
            <path d="M8.375 8.375L15.625 15.625M15.625 8.375L8.375 15.625" stroke="#171717" stroke-width="1.5" stroke-linecap="round"/>
          </svg>
        </button>
      </div>
      
        <div 
          class="new-instance-modal-body modal-body pt-3 m-0 w-100 align-items-center justify-content-between">
          
             <div style="display: flex; flex-wrap: wrap; padding: 0;">
              
             <div class="label-div d-flex align-items-center justify-content-left col-6 ac-line-asset-spacing">
                <p>Substation Name</p>
              </div>
              <div  class="col-6 mb-3" style="padding: 0 7.5px;">
                <lib-object-dropdown
                  [items]="parentSubstations"
                  [displayField]="'name'" 
                  (valueChange)="onSelectParentSubstation($event)"
                  [placeholder]="'Select Substation'"
                  [isRequired]="true"
                  [isSearchEnabled]="true"
                  [maxDisplayItemSize]="10"
                  (searchTextChange)="onSearchTextChange($event)"
                  #parentSubstationDropdown
                ></lib-object-dropdown>
              </div>

               <div class="label-div d-flex align-items-center justify-content-left col-6 ac-line-asset-spacing">
                <p>Incoming AC Line</p>
              </div>

              <div class="col-6 mb-3" style="padding: 0 7.5px;">
                <lib-object-dropdown
                  [items]="outgoingAcLineSegments"
                  [displayField]="'name'" 
                  (valueChange)="onSelectAcLineOutoging($event)"
                  [disabled]="updatedParentSubstationId === null"
                  [placeholder]="'Select Ac Line Segment'"
                  [isRequired]="true"
                  #acLineDropdown
                ></lib-object-dropdown>
              </div>
               <div class="label-div d-flex align-items-center justify-content-left col-6 ac-line-asset-spacing">
                <p>Power transformer</p>
              </div>

              <div class="col-6 mb-3" style="padding: 0 7.5px;">
                <lib-object-dropdown
                  [items]="powerTransformersOnSS"
                  [displayField]="'name'" 
                  (valueChange)="onSelectPowerTransformer($event)"
                  [placeholder]="'Select Power Transformer'"
                  [isRequired]="true"
                  #powerTransformerDropdown
                ></lib-object-dropdown>
              </div>
            </div>
          
        </div>         
      <div class="modal-footer border-0">
        <button type="button" class="btn cancel-modal-btn" data-bs-dismiss="modal" #closeEditModal (click)="resetForm()">Cancel</button>
        <button type="submit" class="btn save-modal-btn">{{ 'Save' }}</button>
      </div>
    </form>
  </div>
</div>